export * from './useSetProductDetailsLocation';
